import axios from 'axios';

const getExpositionByMediaId= (mediaId: number) => axios.get(`medias/${mediaId}/expositions`);

export default { 
    getExpositionByMediaId
};